import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-customers-form',
  templateUrl: './customers-form.component.html',
  styleUrls: ['./customers-form.component.scss'],
})
export class CustomersFormComponent {
  apiUrl = environment.apiUrl;
  url: string = 'users';
  urlTwo: string = 'services';
  id!: string;
  form!: FormGroup;
  roles: Array<any> = [];
  step = 0;
  update = false;
  public services: Array<any> = [];
  public searchedService: any;
  imgModal: string;
  showModal = false;
  showModalImg = false;

  public data = {
    nameService: '',
    ref: '',
    createdAt: '',
    address: '',
    listDropAddress: [],
    pickUptime: '',
    dropOffTime: '',
    distance: '',
    price: '',
    stops: '',
    listStopAddress: [],
    startAddress: '',
    timeStop: '',
    distanceStop: '',
  };

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService
  ) {
    this.form = this.fb.group({
      firstname: ['', [Validators.required]],
      lastname: ['', [Validators.required]],
      business_name: [''],
      username: ['', [Validators.required]],
      role: ['', [Validators.required]],
      status: [''],
      suspended: [''],
      password: [''],
      indicative: [''],
      phone: [''],
      dataAdditional: this.fb.group({
        cards: this.fb.array([
          this.fb.group({
            cardnumber: [''],
            expiration: [''],
          }),
        ]),
      }),
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.selectDataRoles();

      this.id = params['id'];

      if (this.id) {
        this.getData();
        this.selectDataRoles();
        this.getDataCustomer();
      }
    });
  }

  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }

  onSubmit(): void {
    if (this.id) {
      this.updateData();
    } else {
      this.createData();
    }
  }

  getData(): void {
    this.dataService
      .getData(`${this.url}/customer/${this.id}`)
      .subscribe((response) => {
        console.log('reponse getData', response);

        this.form.patchValue({
          firstname: response.rst.firstname,
          lastname: response.rst.lastname,
          business_name: response.rst.business_name ?? null,
          username: response.rst.username,
          role: response.rst.role,
          status: response.rst.status,
          suspended: response.rst.suspended,
          indicative: response.rst.indicative,
          phone: response.rst.phone,
        });

        console.log('form value des', this.form.value);

        const cardsArray = this.form.get('dataAdditional.cards') as FormArray;
        while (cardsArray.length) {
          cardsArray.removeAt(0);
        }

        response.rstAdd?.forEach((card: any) => {
          const cardGroup = this.fb.group({
            cardnumber: [card.cardnumber],
            expiration: [card.expiration],
          });
          cardsArray.push(cardGroup);
        });
      });
  }

  getDataCustomer() {
    this.dataService.getData(`services/client/${this.id}`).subscribe(
    //  this.dataService.getData(`services/client/pending/${this.id}`).subscribe(
      //client/pending
      (response) => {
        let result = response;

        console.log('stttt', result);
        this.services = result.data;
        this.services.sort((a, b) => {
          const dateA = new Date(a.createdAt).getTime();
          const dateB = new Date(b.createdAt).getTime();

          // Ordenar de forma descendente
          return dateB - dateA;
        });

        this.services.forEach((service, index) => {
          service['originalIndex'] = index;
        });

        this.searchedService = this.services.slice();
      },
      (err) => {
        console.log(err);
      }
    );
  }

  createData(): void {
    const formData = {
      ...this.form.value,
    };

    this.dataService
      .postData(`${this.url}/add`, formData)
      .subscribe((response) => {
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.form.reset();
          this.router.navigateByUrl('/logistics/customers');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  updateData(): void {
    const formData = {
      ...this.form.value,
    };

    this.dataService
      .putData(`${this.url}/edit/${this.id}`, formData)
      .subscribe((response) => {
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.form.reset();
          this.router.navigateByUrl('/logistics/customers');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  selectDataRoles(): void {
    this.dataService.getData('roles/select').subscribe((response) => {
      console.log('response.roles', response);
      this.roles = response.data;
    });
  }

  changeStep(step: number) {
    this.step = step;
  }

  get cards() {
    return this.form.get('dataAdditional.cards') as FormArray | null;
  }

  openEmail(email: string) {
    if (!email) return;

    const subject = encodeURIComponent('Contacto desde sistema');
    const body = encodeURIComponent(
      'Hola,\n\nMe comunico contigo desde el sistema.\n\nSaludos.'
    );
    //const gmailComposeUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${subject}&body=${body}`;
    const gmailComposeUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}`;

    const chooserUrl = `https://accounts.google.com/AccountChooser?continue=${encodeURIComponent(
      gmailComposeUrl
    )}`;

    window.open(chooserUrl, '_blank');
  }

  enableUpdate() {
    this.update = !this.update;
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const month = date.toLocaleString('en-EN', { month: 'long' });
    const day = date.getDate();
    const year = date.getFullYear();
    const newDate = `${month} ${day}/${year}`;

    return newDate;
  }

  getNumber(index: number): number {
    let count = 0;
    for (let i = 0; i <= index; i++) {
      if (this.services[i]['data'][0].when['nameService'] === 'RUNNER') {
        count++;
      }
    }
    return count;
  }

  searchService(event: any) {
    const text = event.target.value;
    this.searchedService = this.services;

    if (text && text.trim() != '') {
      //text.trim texto no vacio, o solo espacios en blanco
      this.searchedService = this.searchedService.filter((service: any) => {
        return service['ref'].toLowerCase().indexOf(text.toLowerCase()) > -1;
      });
    }
  }

  openModal() {
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }

  getDataService(id: string): void {
    this.dataService.getData(`${this.urlTwo}/${id}`).subscribe(
      (response) => {
        let result = response;
        this.data.listDropAddress = [];
        console.log('resultado de service', result);
        //console.log('resultado de service2', result['rst'].data[0].listDrop.length);

        this.data.nameService = result['rst'].data[0].when['nameService'];
        this.data.ref = result['rst']['ref'];
        this.data.createdAt = result['rst']['createdAt'];
        this.data.address = result['rst'].data[0].fullAddress;
        this.data.pickUptime = result['rst'].data[0]['open'];

        this.data.dropOffTime = result['rst'].data[0].drop['close'];
        this.data.distance = result['rst'].data[0].drop['distance']['distance'];

        this.data.price = result['rst']['total'];

        //if (this.data.nameService != 'RUNNER') {
        for (let i = 0; i < result['rst'].data[0].listDrop.length; i++) {
          this.data.listDropAddress.push(
            result['rst'].data[0].listDrop[i].fullAddress
          );
        }
        //}

        this.openModal();
        console.log('resultado de servicio', this.data);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  back() {
    this.router.navigateByUrl('/logistics/customers');
  }
}
